import { render, staticRenderFns } from "./productSort.vue?vue&type=template&id=664ad1eb&"
import script from "./productSort.vue?vue&type=script&lang=js&"
export * from "./productSort.vue?vue&type=script&lang=js&"
import style0 from "./productSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports